import React, { useEffect, useState } from "react";
import { View, Text, StyleSheet, TouchableOpacity } from "react-native";
import { Switch } from "react-native-switch";
import Ionicons from "react-native-vector-icons/Ionicons";
import { android, web } from "./Platform";

const Swatch = ({ size = 15, value = true, onChange = () => {} }) => {
  const [iValue, setIValue] = useState(value);
  useEffect(() => {
    setIValue(value);
  }, [value]);
  return (
    <View
      style={[
        {
          alignItems: "center",
          justifyContent: "center",
          flex: 1,
        },
        web ? { cursor: "pointer" } : {},
      ]}
    >
      <Switch
        value={value}
        onValueChange={() => {
          setIValue(!value);
          onChange(!value);
        }}
        activeText="YES"
        inActiveText="NO"
        activeTextStyle={{
          color: "white",
          fontWeight: "bold",
          fontSize: size - 2 || 15,
          fontFamily: web
            ? '"Helvetica Neue", Helvetica, Arial, sans-serif'
            : "OpenSansBold",
        }}
        inactiveTextStyle={{
          color: "#777",
          fontWeight: "bold",
          fontSize: size - 2 || 15,
          fontFamily: web
            ? '"Helvetica Neue", Helvetica, Arial, sans-serif'
            : "OpenSansBold",
        }}
        barHeight={size ? size + 10 : 25}
        circleSize={size ? size + 15 : 30}
        switchLeftPx={5}
        switchRightPx={android ? 3 : 5}
        circleBorderActiveColor="#8AB2C9"
        backgroundActive="#8AB2C9"
        backgroundInactive="#0000003d"
        circleBorderInActiveColor="#797979"
        innerCircleStyle={{
          shadowColor: "#000",
          shadowOffset: { width: 0, height: 3 },
          shadowOpacity: 0.5,
          shadowRadius: 9,
        }}
        renderInsideCircle={() => (
          <View
            style={{
              height: size || 15,
              transform: [{ rotate: "270deg" }],
            }}
          >
            <Ionicons
              name="menu"
              size={size || 15}
              color={iValue ? "#8AB2C9" : "#777"}
            />
          </View>
        )}
      />
    </View>
  );
};

export default Swatch;
